// extracted by mini-css-extract-plugin
export default {"container":"container§UfQSxSwljHUiUH7MwSpe","logoWrap":"logoWrap§jsWqP2ECQqc9Jb8g_f67","logo":"logo§_SCP0GBhz2dUmiaEY2l_","text":"text§qHd3DcP8I0JAFAPGh3Cv"};